import { AppError } from '@shared/api/error'
import { apiFetch } from '@shared/api/http'
import { CoproductionInviteSchema } from './coproduction.contract'
import type { CoproductionInvite } from './coproduction.contract'

export const coproductionKeys = {
  adminForProduct: (productId: string) =>
    ['admin', 'partnerships', 'coproductions', productId] as const,
}

export async function getAdminCoproductionForProduct(
  productId: string,
): Promise<CoproductionInvite | null> {
  try {
    const data = await apiFetch<unknown>(`/admin/products/${productId}/coproduction`)
    if (data === null || data === undefined) {
      return null
    }
    return CoproductionInviteSchema.parse(data)
  } catch (error) {
    if (error instanceof AppError && error.status === 404) {
      return null
    }
    throw error
  }
}
